import { useEffect } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import heroVilla from "@/assets/hero-villa.jpg";

const NotFound = () => {
  useEffect(() => {
    document.title = "Page Not Found | Hadassah Homes";

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "The page you’re looking for may have been moved, removed, or no longer exists. Let’s get you back on track."
      );
    }

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }

    canonical.href = "https://hadassahhomesinc.com/404";
  }, []);

  return (
    <SiteLayout>
      <section className="relative min-h-[calc(100vh-120px)] overflow-hidden bg-[#173D2D]">
        <img
          src={heroVilla}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          aria-hidden="true"
        />
        <div
          className="absolute inset-0 bg-black/65"
          aria-hidden="true"
        />

        <div className="relative z-10 mx-auto flex min-h-[calc(100vh-120px)] max-w-3xl flex-col items-center justify-center px-5 py-24 text-center">
          <div className="space-y-6">
            <p className="font-body text-xs font-medium uppercase tracking-[0.22em] text-[#C9A95C]">
              Page Not Found
            </p>
            <h1 className="font-headline text-5xl leading-tight text-white md:text-6xl">
              This Page Doesn&apos;t Exist
            </h1>
            <p className="mx-auto max-w-2xl text-lg leading-relaxed text-white/80">
              The page you&apos;re looking for may have been moved, removed, or no longer
              exists. Let&apos;s get you back on track.
            </p>
            <div className="flex flex-col items-center justify-center gap-3 pt-2 sm:flex-row">
              <Link
                to="/"
                className="inline-flex min-w-[190px] items-center justify-center rounded-none bg-[#C9A95C] px-6 py-3 font-body text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors hover:bg-[#b89a50] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A95C]/70 focus-visible:ring-offset-2 focus-visible:ring-offset-[#173D2D]"
              >
                Back to Home
              </Link>
              <Link
                to="/listings"
                className="inline-flex min-w-[190px] items-center justify-center rounded-none border border-white/30 px-6 py-3 font-body text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#173D2D]"
              >
                Explore Properties
              </Link>
            </div>
            <div className="pt-1">
              <Link
                to="/consultation"
                className="font-body text-sm uppercase tracking-[0.14em] text-[#C9A95C] transition-colors hover:text-white"
              >
                Book a Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default NotFound;
